import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RadioIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RadioIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.4135 7.05343H6.87376V6.64283L20.5049 3.52696C20.82 3.45493 21.0171 3.14106 20.945 2.82593C20.873 2.51085 20.5593 2.31384 20.244 2.38579L6.58669 5.50767C6.2727 5.02913 5.73173 4.71226 5.11788 4.71226C4.14969 4.71226 3.362 5.49995 3.362 6.46814V7.1541C2.68076 7.39571 2.19141 8.04628 2.19141 8.80931V20.5931C2.19141 21.5613 2.9791 22.349 3.94729 22.349H20.4134C21.3816 22.349 22.1693 21.5613 22.1693 20.5931V8.80931C22.1693 7.84112 21.3816 7.05343 20.4135 7.05343ZM4.53258 6.46814C4.53258 6.14541 4.79514 5.88285 5.11787 5.88285C5.4406 5.88285 5.70316 6.14541 5.70316 6.46814V7.05343H4.53257L4.53258 6.46814ZM20.9988 20.5932C20.9988 20.9159 20.7362 21.1784 20.4135 21.1784H3.94729C3.62456 21.1784 3.362 20.9159 3.362 20.5932V8.80932C3.362 8.48659 3.62456 8.22403 3.94729 8.22403H20.4135C20.7362 8.22403 20.9988 8.48659 20.9988 8.80932V20.5932Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.2425 9.39441H5.11752C4.79428 9.39441 4.53223 9.65647 4.53223 9.9797V13.5304C4.53223 13.8537 4.79429 14.1157 5.11752 14.1157H19.2425C19.5658 14.1157 19.8278 13.8537 19.8278 13.5304V9.97966C19.8278 9.65646 19.5658 9.39441 19.2425 9.39441ZM13.9749 12.9451H5.70281V10.565H13.9749V12.9451ZM18.6572 12.9451H17.4866V12.3599C17.4866 12.0366 17.2246 11.7746 16.9013 11.7746C16.5781 11.7746 16.3161 12.0366 16.3161 12.3599V12.9451H15.1455V10.565H18.6572L18.6572 12.9451Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.4867 15.326C16.1958 15.326 15.1455 16.3763 15.1455 17.6672C15.1455 18.9581 16.1958 20.0084 17.4867 20.0084C18.7776 20.0084 19.8278 18.9581 19.8278 17.6672C19.8278 16.3763 18.7776 15.326 17.4867 15.326ZM17.4867 18.8378C16.8412 18.8378 16.3161 18.3126 16.3161 17.6672C16.3161 17.0217 16.8412 16.4966 17.4867 16.4966C18.1321 16.4966 18.6573 17.0217 18.6573 17.6672C18.6573 18.3126 18.1321 18.8378 17.4867 18.8378Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.8734 15.326C5.58248 15.326 4.53223 16.3763 4.53223 17.6672C4.53223 18.9581 5.58248 20.0084 6.8734 20.0084C8.16432 20.0084 9.21457 18.9581 9.21457 17.6672C9.21453 16.3763 8.16432 15.326 6.8734 15.326ZM6.8734 18.8378C6.22794 18.8378 5.70281 18.3126 5.70281 17.6672C5.70281 17.0217 6.22794 16.4966 6.8734 16.4966C7.51886 16.4966 8.04399 17.0217 8.04399 17.6672C8.04399 18.3126 7.51886 18.8378 6.8734 18.8378Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.3898 16.496H10.9705C10.6473 16.496 10.3853 16.758 10.3853 17.0813C10.3853 17.4045 10.6473 17.6666 10.9705 17.6666H13.3898C13.713 17.6666 13.975 17.4045 13.975 17.0813C13.975 16.758 13.713 16.496 13.3898 16.496Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.3898 18.8378H10.9705C10.6473 18.8378 10.3853 19.0998 10.3853 19.4231C10.3853 19.7463 10.6473 20.0083 10.9705 20.0083H13.3898C13.713 20.0083 13.975 19.7463 13.975 19.4231C13.975 19.0998 13.713 18.8378 13.3898 18.8378Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default RadioIcon;
